import { useMemo } from 'react';
import { buildVerificationUris } from './verfication-uri.js';

export function useColoredVerificationUri(verificationUri: string) {
  return useMemo(() => {
    return buildVerificationUris(verificationUri);
  }, [verificationUri]);
}
